import template from './address.html';
import _ from 'lodash';

const AddressFields = [/*name, 'address',*/ 'postcode', 'city', 'phone', 'fax'];

export const addressComponent = {
  name: 'address',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  controller: function($element) {
    'ngInject';
    this.$onInit = function() {
      this.fields = AddressFields;

      // Set state specific class names
      const classNames = getClassNames(this);
      if (classNames) {
        $element.addClass(classNames.join(' '));
      }
  
      // Is given address empty
      this.emptyAddress = _.reduce(this.fields, (empty, field) => {
        return empty && !this.model[field];
      }, true);
    };

  },
  bindings: {
    model: '<',
    multiLine: '<',
    decent: '<'
  }
};

function getClassNames(obj) {
  const classNames = [];
  const { multiLine, decent } = obj;

  if (multiLine) {
    classNames.push('multi-line');
  }

  if (decent) {
    classNames.push('decent-text');
  }

  return classNames.length && classNames;
}
